import React, { useMemo, useState } from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  Typography,
  Checkbox,
  Grid,
  MenuItem,
  TextField,
  Button,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@mui/material";
import { useEffect } from "react";
import Link from "@mui/material/Link";
import axios from "axios";
import { API } from "../../pages/backend";
import { useNavigate, useLocation } from "react-router-dom";
// import toast from "react-hot-toast";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import data from "../dropDown";
import Swal from "sweetalert2";
import Spinner from "../ui/Spinner";
import { useDispatch } from "react-redux";
import { loggedInUser, setUser } from "../../store/reducers/user";
import FormButton from "../ui/button/FormButton";
import InputField from "../forms/input/TextInput/InputField";
import { apiRequest, baseURL } from "../../services/auth";
import { closeModal, showModal } from "../../store/reducers/modal";


const RegisterFormPubModel = ({
  examType = "PUBLIC SERVICE REGISTRATION",
  serviceType,
  navigateTo,
  homeLink
}) => {
  const formSchema = yup.object().shape({
    firstName: yup
      .string()
      .required("First Name is required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "First Name should not contain numbers"),
    lastName: yup
      .string()
      .required("Last Name is required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "Last Name should not contain numbers"),
    middleName: yup
      .string(),
      // .required("Middle Name is required")
      // .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "Middle Name should not contain numbers"),
    email: yup
      .string()
      .required("Email can't be empty")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalid Email Address"
      ),
      phoneNumber: yup
      .string()
      .required("Phone Number is required")
      .matches(/^\d{11}$/, "Phone number must be exactly 11 digits"),
    
    // payerId: yup.string().required("Payer ID is required"),

    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
      //   "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      // ),
    confirm: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required")
      .min(8, "Password must be at least 8 characters"),
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
      //   "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      // ),
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { Lga } = data;

  // useform
  const {
    setValue,
    setFocus,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(formSchema),
  });


 
  const Register = async () => {
    setLoading(true)
    dispatch(closeModal(<></>))
    const submitUrl =
    serviceType === "model"
      ? `/individual/register/01`
      : `/individual/register/02`;

    let value = watch();
    // console.log(value);
    const isValid = await trigger(); // Trigger validation
    // console.log(isValid)
    // Do not proceed if there are validation errors
    if (!isValid) return;
    try {
      const response = await fetch(`${baseURL}${submitUrl}`, {
        body: JSON.stringify(value),
        method : 'POST',
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const result = await response.json();
      const res = {
        data: result,
        hasError: !response.ok,
        status: response.status,
        statusText: response.statusText,
      };
      if(!res.hasError ) {
        navigate(navigateTo);
        Swal.fire({
          title: "Successful",
          text: res?.data?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
        dispatch(setUser(res?.data?.data?.details));
        console.log(res.data)

        setLoading(false)
        

      } else {
        
        Swal.fire({
          title: "Failed",
          text: res.data.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
    setLoading(false)

      }

      // console.log(res) ;
    } catch (error) {
    setLoading(false)
      
      console.log(error)
      
    }
    
  };

  const location = useLocation();
  const [loginPage, setLoginPage] = useState(null);

  const isDisabled = useMemo(() => {
    const {
      firstName,
      lastName,
      // middleName,
      phoneNumber,
      email,
      password,
      confirm,
    } = watch();

    let bool =
      firstName &&
      lastName &&
      password &&
      confirm &&
      phoneNumber?.length === 11 &&
      password === confirm && 
      email;
    
    return !bool;
  }, [watch()]);

  useEffect(() => {
    if (location.pathname === "/public/payment/register") {
      setLoginPage("/public/payment/login");
    } else if (location.pathname === "/model/payment/register")
      setLoginPage("/model/payment/login");
  }, [location.pathname]);

  

  const registerConfirm = () => {
    let value = watch();
    trigger().then((isValid) => {
      if (!isValid) return;
    });
    dispatch(
      showModal({
        content: (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <Typography
              style={{
                display: "flex",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              Please confirm your details before proceeding
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "5px",
              }}
            >
              <Typography>
                {" "}
                Name:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {value?.firstName} {value?.middleName} {value?.lastName}
                </span>
              </Typography>
              <Typography>
                Email:{" "}
                <span style={{ fontWeight: "bold" }}>{value?.email}</span>
              </Typography>
              <Typography>
                PhoneNumber:{" "}
                <span style={{ fontWeight: "bold" }}>{value?.phoneNumber}</span>
              </Typography>
            </div>

            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                justifyContent: "space-between",
              }}
            >
              <FormButton
                label={"Cancel"}
                width="medium"
                onClick={() => dispatch(closeModal(<></>))}
              />
              <FormButton
                label={loading ? <Spinner width="5%" /> : "Proceed"}
                width="medium"
                onClick={Register}
                type="submit"
              />
            </Box>
          </div>
        ),
      })
    );
  };




  return (
    <div >
      <Card
        className="register-card-pubmod"
        elevation={5}
        style={{
          boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px",
          border: "2px solid #34A56F",
        }}
      >
        <Container component="div">
          <Stack style={{ textAlign: "center", paddingTop: "2rem" }}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              EXAM PORTAL REGISTRATION
            </Typography>
            <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
              {" "}
              {examType}{" "}
            </Typography>
          </Stack>
          <div
            // style={{
            //   padding: "30px 40px",
            // }}
          >
            <form
            // onSubmit={handleSubmit(Register)}
            // onSubmit={Register}
            >
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                  <InputField
                      name="lastName"
                      label="Surname"
                      type="lastName"
                      placeholder="SurName"
                      // value={lastName}
                      onChange={(e) => {
                        setValue("lastName", e.target.value);
                      }}
                      style={{ height: "100%" }}
                    />

                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.lastName ? "visible" : "hidden",
                      }}
                    >
                      {errors.lastName?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <InputField
                      name="firstName"
                      label="First Name"
                      type="firstName"
                      placeholder="First Name"
                      onBlur={() => trigger("firstName")}
                      onChange={(e) => {
                        setValue("firstName", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.firstName ? "visible" : "hidden",
                      }}
                    >
                      {errors.firstName?.message}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputField
                      name="middleName"
                      label="Other Name"
                      type="lastName"
                      placeholder="Other Name"
                      // value={lastName}
                      onChange={(e) => {
                        setValue("middleName", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.middleName ? "visible" : "hidden",
                      }}
                    >
                      {errors.middleName?.message}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <InputField
                      name="phoneNumber"
                      label="Phone Number"
                      type="phoneNumber"
                      placeholder="Phone Number"
                      onBlur={() => trigger("phoneNumber")}
                      // value={phone}
                      onChange={(e) => {
                        setValue("phoneNumber", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.phoneNumber ? "visible" : "hidden",
                      }}
                    >
                      {errors.phoneNumber?.message}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <Grid container>
                <Grid xs={12}>
                  <InputField
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Email"
                    // value={email}
                    onBlur={() => trigger("email")}
                    onChange={(e) => {
                      setValue("email", e.target.value.trim());
                    }}
                    style={{ height: "100%" }}
                  />
                  <Typography
                    sx={{
                      color: "#e53e3e",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    style={{
                      visibility: errors.email ? "visible" : "hidden",
                    }}
                  >
                    {errors.email?.message}
                  </Typography>
                </Grid>
              </Grid>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputField
                      name="password"
                      label="Password"
                      type="password"
                      placeholder="Password"
                      // value={password}
                      onBlur={() => trigger("password")}
                      password
                      onChange={(e) => {
                        setValue("password", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                        paddingLeft: "20px",
                      }}
                      // style={{
                      //   visibility: errors.password ? "visible" : "hidden",
                      // }}
                    >
                      {errors.password?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputField
                      name="confirm"
                      label=" Confirm Password"
                      type="confirm"
                      placeholder=" Confirm Password"
                      password
                      // value={confirmPassword}
                      onBlur={() => trigger("confirm")}
                      onChange={(e) => {
                        setValue("confirm", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    
                  </Grid>
                  <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {errors.confirm?.message}
                     
                    </Typography>
                </Grid>
              </div>

              <Stack style={{ marginTop: "10px" }}>
                {/* Register Button */}
                <FormButton
                  type="button"
                  label={loading ? <Spinner width="5%" /> : "Register"}
                  width="full"
                  disabled={isDisabled}
                  onClick={registerConfirm}
                  // onClick={Register}
                />
              </Stack>

              <Typography
                variant="body2"
                fontWeight="normal"
                marginTop="10px"
                textAlign="center"
                cursor="pointer"
                color="#807c7c"
              >
                Already signed up? {"   "}
                {"   "}
                <Link
                  href={loginPage}
                  style={{
                    textDecoration: "none",
                    color: "#34A56F",
                    fontWeight: "bold",
                  }}
                >
                  {"  "}
                  Login
                </Link>
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                marginTop="10px"
                textAlign="center"
                cursor="pointer"
                color="secondary"
              >
                <Link
                 href={homeLink}
                    target="_blank" rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#34A56F",
                    fontWeight:"normal"
                  }}
                >
                  {"  "}
                  Back to home page
                </Link>
              </Typography>
            </form>
          </div>
          {/* <Footer /> */}
        </Container>
      </Card>
    </div>
  );
};

export default RegisterFormPubModel;